if (!customElements.get('product-form')) {

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // const formData = new FormData(this.form);
        // if (this.cart) {
        //   formData.append(
        //     'sections',
        //     this.cart.getSectionsToRender().map((section) => section.id)
        //   );
        //   formData.append('sections_url', window.location.pathname);
        //   this.cart.setActiveElement(document.activeElement);
        // }
        // config.body = formData;

       const formData = new FormData(this.form);

if (this.cart) {
  const sections = this.cart.getSectionsToRender().map((section) => section.id);
  console.log('Sections to render:', sections);
  
  sections.forEach((section) => {
    formData.append('sections[]', section);
  });
  
  formData.append('sections_url', window.location.pathname);
  this.cart.setActiveElement(document.activeElement);
  
  // Log the actual FormData being sent
  console.log('FormData sections:', Array.from(formData.entries()).filter(e => e[0].includes('section')));
}

config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          
          .then((response) => {
             console.log('Cart Add Response:', response);  //  for debugging
    console.log('Sections:', response.sections); 
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    //   setTimeout(function(){
                    //        //this.cart.renderContents(response);
                    //        refreshCartAndRender(this.cart);
                    //   },1000);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
               this.cart.renderContents(response);
              // refreshCartAndRender(this.cart);

              });
                console.log("test2");
            //   setTimeout(function(){
            //   //document.querySelector('.cart__checkout-button').disabled = false;
            //    if(document.querySelector('.gokwik-checkout')){
            //  document.querySelector('.gokwik-checkout').classList.remove('disabled-btn');
            //    }
            //   }, 1500);

            }
            window.move_desktop_slide_js();
          })

          
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
             setTimeout(function(){
             // document.querySelector('.cart__checkout-button').disabled = false;
              // if(document.querySelector('.gokwik-checkout')){
              //  document.querySelector('.gokwik-checkout').classList.remove('disabled-btn');
              // }
              }, 1500);
            window.updateCartTotal();
            //window.fireKwikCartEvent();
             if (typeof window.updateBundleCards === "function") {
              window.updateBundleCards();
            }
            setTimeout(function(){
            if (typeof window.initFlashSaleTimer === "function") {
              window.initFlashSaleTimer();
            }
          }, 1500);
              if (typeof window.renderCartWaiting === "function") {
              window.renderCartWaiting();
            }
            //window.progress_gifts();
            console.log(evt,"---evt");
            const wrapper = evt.target.closest('.product__info-wrapper');
            console.log(wrapper,"---wrapper");
            if(wrapper){
              if (document.body.classList.contains('template-product')) {
                const qtySelector = document.querySelector('.quantity-selector');
                const styBtn = document.querySelector('.sticky-form__submit');

                if (window.getComputedStyle(qtySelector).display === 'none') {
                  qtySelector.style.display = 'flex';
                  styBtn.style.display = 'none';
                } else {
                  let qtyInput = document.querySelector('.sticky_quantity');
                  let currentQty = parseInt(qtyInput.value) || 0; // get current value
                  qtyInput.value = currentQty + 1;
                }
              }
            }
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
